@import '~style-sheet-helpers/core.less';

.page {
  width: 100%;
  height: 100%;
}
